import {createContext} from 'react'

export const ProductBadgesPageContext = createContext({
  hasWritePermission: false,

  productBadgesList: [] as any[],
  isLoading: false,
  filters: {},
  onSearch: (searchValue: string) => {},
  onSortingChange: (key: string, value: string) => {},

  deleteProductBadge: (badgeId: string) => {},
  toggleProductBadgeStatus: (badgeId: string, status: string) => {},
  isOperationLoading: false,
})
